import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import DrcMain from '../Components/DrcMain';
import { DriscollsLogin, withAuth } from '@driscollsinc/login-module-ui';
import DrcImage from '../Components/DrcImage';

var styles = (theme) => ({
    login: {
        height: 'calc(100vh - 100px)',
        position: 'relative',
        '& > div': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateY(-50%) translateX(-50%)'
        },
        '& #okta-sign-in .auth-content': {
            padding: 20
        },
        '& #okta-sign-in .okta-sign-in-header': {
            display: 'none'
        },
        '& #okta-sign-in.auth-container.main-container': {
            boxShadow: '0px 5px 14px 0px rgba(0, 0, 0, 0.62)',
            width: 350
        },
        '& #okta-sign-in.auth-container .okta-form-label': {
            position: 'relative',
            zIndex: 1,
            margin: '-10px 0 -15px 14px'
        },
        '& #okta-sign-in .o-form .input-fix input': {
            borderRadius: '6px !important'
        },
        '& #okta-sign-in .o-form .okta-form-label label': {
            backgroundColor: '#fff',
            paddingLeft: 3,
            '@media (prefers-color-scheme: dark)': {
                backgroundColor: '#000'
            }
        }
    },
    poly: {
        '& #okta-sign-in.auth-container #okta-signin-submit': {
            borderRadius: 25
        }
    },
    image: {
        position: 'absolute',
        height: '100vh',
        width: '100vw',
        top: 0,
        left: 0,
        objectFit: 'cover',
        zIndex: -5,
        '@media (prefers-color-scheme: dark)': {
            opacity: 0.2
        }
    }
});

class DrcPageLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authenticated: null
        };

        this.checkAuthentication = this.checkAuthentication.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onError = this.onError.bind(this);
    }

    async checkAuthentication() {
        const authenticated = this.props.authState.isAuthenticated;
        if (authenticated !== this.state.authenticated) {
            this.setState({ authenticated });
        }
    }

    async componentDidMount() {
        if (this.props.setPageTitle) {
            this.props.setPageTitle('');
        }

        this.checkAuthentication();
    }

    async componentDidUpdate() {
        this.checkAuthentication();
    }

    onSuccess(res) {
        if (res.status === 'SUCCESS') {
            return this.props.auth.redirect({
                sessionToken: res.session.token
            });
        } else {
            // The user can be in another authentication state that requires further action.
            // For more information about these states, see:
            //   https://github.com/okta/okta-signin-widget#rendereloptions-success-error
        }
    }

    onError(err) {
        console.error('error logging in', err);
    }

    render() {
        return this.state.authenticated ? (
            <Navigate to={this.props.redirect || '/InitializeApplication/'} />
        ) : (
            <React.Fragment>
                <DrcMain transparent>
                    <DrcImage src={this.props.backgroundPng} webp={this.props.backgroundWebP} className={this.props.classes.image} alt="" />
                    <DriscollsLogin
                        baseUrl={window.config.OKTA_URL}
                        onSuccess={this.onSuccess}
                        onError={this.onError}
                        config={this.props.config ?? {}}
                        appVersion={process.env.REACT_APP_VERSION}
                    />
                </DrcMain>
            </React.Fragment>
        );
    }
}

export default withAuth(withStyles(styles)(DrcPageLogin));
